var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Card, CardContent, Stack, TextField, Typography, } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
export var DivisionForm = function (_a) {
    var onSubmit = _a.onSubmit, seasonId = _a.seasonId, _b = _a.existingDivisions, existingDivisions = _b === void 0 ? [] : _b, division = _a.division;
    var _c = useForm({
        defaultValues: {
            name: (division === null || division === void 0 ? void 0 : division.name) || "",
            tier: (division === null || division === void 0 ? void 0 : division.tier) || 1,
            description: (division === null || division === void 0 ? void 0 : division.description) || "",
            season: seasonId,
        },
    }), control = _c.control, handleSubmit = _c.handleSubmit, errors = _c.formState.errors;
    // Validation helpers
    var validateUniqueName = function (name) {
        if (!name)
            return true; // Let required validation handle empty names
        var trimmedName = name.trim();
        if (!trimmedName)
            return true;
        var existingName = existingDivisions.find(function (div) {
            return div.name.toLowerCase() === trimmedName.toLowerCase() &&
                div.id !== (division === null || division === void 0 ? void 0 : division.id);
        } // Allow current division name when editing
        );
        return !existingName || "A division with this name already exists";
    };
    var handleFormSubmit = function (data) {
        onSubmit(__assign(__assign({}, data), { season: seasonId, id: division === null || division === void 0 ? void 0 : division.id }));
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: division ? "Update Division" : "Create Division" }), _jsx(Box, { component: "form", role: "form", onSubmit: handleSubmit(handleFormSubmit), sx: { mt: 1 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Controller, { name: "name", control: control, rules: {
                                    required: "Division name is required",
                                    validate: validateUniqueName,
                                }, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (_jsx(TextField, __assign({}, field, { label: "Division Name", placeholder: "e.g., Premier League, Championship", required: true, fullWidth: true, error: !!errors.name, helperText: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                } }), _jsx(Controller, { name: "tier", control: control, rules: {
                                    required: "Tier is required",
                                    min: { value: 1, message: "Tier must be at least 1" },
                                    max: { value: 10, message: "Tier cannot exceed 10" },
                                }, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (_jsx(TextField, __assign({}, field, { label: "Tier", type: "number", required: true, fullWidth: true, inputProps: { min: 1, max: 10 }, helperText: ((_b = errors.tier) === null || _b === void 0 ? void 0 : _b.message) ||
                                            "1 = highest tier, 2 = second tier, etc. Multiple divisions can share the same tier.", error: !!errors.tier, onChange: function (e) { return field.onChange(parseInt(e.target.value)); } })));
                                } }), _jsx(Controller, { name: "description", control: control, render: function (_a) {
                                    var field = _a.field;
                                    return (_jsx(TextField, __assign({}, field, { label: "Description (Optional)", multiline: true, rows: 3, fullWidth: true, placeholder: "Optional description for this division" })));
                                } }), _jsx(Button, { type: "submit", variant: "contained", fullWidth: true, sx: { mt: 3, mb: 2 }, disabled: Object.keys(errors).length > 0, children: division ? "Update Division" : "Create Division" })] }) })] }) }));
};
